export default {
     getProgressDesc(progressCode) {
        console.log(progressCode);
        switch (progressCode) {
            case 'CONTINUE':
                return '正在学习'
            case 'EXAMINATION':
                return '正在考试'
            case 'PRACTICAL':
                return '理论完成'
            case 'PARTICIPATION':
                return '理论完成'
            case 'PRACTICALCOMPLETION':
                return '理论完成'
            default:
                return ''
        }
        return '';
    }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js